import type { ItemType } from "types"
import { useUser } from "lib/user"

export function useBasket(): ItemType[] {
  const { basket = [] } = useUser()

  return basket
}
